export default __webpack_public_path__ + "static/trent-willis-5c76106053f67394dfe994f57e50b5ce.jpg";